import axios from 'axios';
import { Dispatch, SetStateAction, useState } from 'react';
import ReactCodeInput from 'react-code-input';
import { useDispatch } from 'react-redux';
import Spinner from '../../../components/common/Spinner';
import { P2, P3 } from '../../../styles/FontStyles';
import {
  Button,
  Flexed,
  SecurityCodeWrapper
} from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { FlexCenter } from '../../../styles/stylesStyled';
import { createWithdrawExplorer } from '../../Earnings/Withdraw/Withdraw.actions';
import { Title } from '../../Settings/SettingsStyled';

import { useAppSelector } from '../../../app/hooks';
import {
  ErrorToast,
  SuccessToast
} from '../../../components/common/Toasts/Toasts';
import { WithdrawSteps, WithdrawAvailability } from '../Portfolio.types';
import { UserWalletModel } from '../../../types/wallets-types';

interface TwoFASetupProps {
  setStep: Dispatch<SetStateAction<WithdrawSteps>>;
  setAmount: Dispatch<SetStateAction<string>>;
  selected: number;
  userWallets: UserWalletModel[];
  amount: string;
  withdrawAvailabilitySteps: number;
}

export const TwoFASetup = ({
  setStep,
  setAmount,
  amount,
  userWallets,
  selected,
  withdrawAvailabilitySteps
}: TwoFASetupProps) => {
  const dispatch = useDispatch();

  const [code, setCode] = useState('');
  const [code2Fa, setCode2Fa] = useState('');
  const [loadingCode, setLoadingCode] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  const { verificationStatus } = useAppSelector((state) => state.settings);
  const { loading: loadingWithdraw } = useAppSelector(
    (state) => state.withdraw
  );
  const { user } = useAppSelector((state) => state.auth.userInfo);

  const sendCode = async () => {
    try {
      setLoadingCode(true);
      await axios.post(`/explorer/withdraw/email/code`, {
        amount: parseInt(amount),
        userWalletId: userWallets[selected].id
      });

      SuccessToast('Code sent successfully');
      setLoadingCode(false);
      setIsCodeSent(true);
    } catch (error: any) {
      setLoadingCode(false);
      ErrorToast(error.response.data.error);
    }
  };

  const sendCodeUSDT = async () => {
    try {
      setLoadingCode(true);
      await axios.post(`/explorer/gaming-usdt/withdraw/email/code`, {
        amount: parseInt(amount),
        userWalletId: userWallets[selected].id
      });

      SuccessToast('Code sent successfully');
      setLoadingCode(false);
      setIsCodeSent(true);
    } catch (error: any) {
      setLoadingCode(false);
      ErrorToast(error.response.data.error);
    }
  };

  const onHandleSubmit = (e: any) => {
    e.preventDefault();

    if (!code) {
      ErrorToast('Please enter email verification code');
    } else if (!code2Fa) {
      ErrorToast('Please enter 2FA code');
    } else {
      dispatch(
        createWithdrawExplorer({
          amount: parseInt(amount),
          userWalletId: userWallets[selected].id,
          setStep,
          emailCode: code,
          twoFACode: code2Fa,
          setAmount,
          withdrawAvailabilitySteps
        })
      );
    }
  };

  return (
    <div style={{ marginTop: '20vh' }}>
      <FlexCenter style={{ flexDirection: 'column' }}>
        {loadingCode || loadingWithdraw ? (
          <Spinner />
        ) : (
          <>
            <Title style={{ marginBottom: 60 }}>Security verification</Title>
            <form onSubmit={onHandleSubmit}>
              <Flexed between>
                <P2 bold color={color.colors.neutral700}>
                  Email verification code
                </P2>
                <P2
                  bold
                  style={{ cursor: 'pointer' }}
                  color={color.colors.primary900}
                  onClick={() => {
                    withdrawAvailabilitySteps === WithdrawAvailability.ULX
                      ? sendCode()
                      : sendCodeUSDT();
                  }}>
                  Send Code
                </P2>
              </Flexed>
              <SecurityCodeWrapper>
                <ReactCodeInput
                  fields={7}
                  value={code}
                  onChange={setCode}
                  type={'number'}
                  name='ReactCodeInput'
                  inputMode='numeric'
                />
              </SecurityCodeWrapper>
              <P3 color={color.colors.neutral500} mb='40'>
                {isCodeSent && `Enter the 7 digit code sent to ${user?.email}`}
              </P3>

              {verificationStatus && (
                <div>
                  <Flexed between>
                    <P2 bold color={color.colors.neutral700}>
                      2FA verification code
                    </P2>
                  </Flexed>
                  <SecurityCodeWrapper is2Fa>
                    <ReactCodeInput
                      fields={6}
                      value={code2Fa}
                      onChange={setCode2Fa}
                      type={'number'}
                      name='ReactCodeInput2'
                      inputMode='numeric'
                    />
                  </SecurityCodeWrapper>
                  <P3 color={color.colors.neutral500} mb='10'>
                    Enter the 6 digit code from your 2FA authenticator
                  </P3>
                </div>
              )}
              <Button
                m='30px 0 10px 0'
                type='submit'
                disabled={code === '' ? true : false}>
                Confirm
              </Button>
            </form>
          </>
        )}
      </FlexCenter>
    </div>
  );
};
